import { Flex } from "@chakra-ui/react";
import Form from "components/Customers/CustomerPage/ProductDetails/Form";
import { CancelButton, SaveButton } from "components/Products/EditPanelContent";
import useCreateSkuBrandOrderingPlatform from "components/Customers/CustomerPage/ProductDetails/useCreate";
import SkuOrderingPlatformItemContainer from "./ItemContainer";

type Props = {
  onCancel?: () => void;
  onCompleted?: () => void;
  skuId: UUID | null | undefined;
};

export default function SkuOrderingPlatformCreate({
  onCancel,
  onCompleted,
  skuId,
}: Props) {
  const { handleValidSubmit, isCreating } = useCreateSkuBrandOrderingPlatform(
    {
      skuId,
    },
    {
      successMessage: "Customer added successfully.",
      onUpdateComplete: onCompleted,
    },
  );
  return (
    <SkuOrderingPlatformItemContainer>
      <Form
        onValidSubmit={handleValidSubmit}
        isSkuHidden
        skuId={skuId}
        footer={
          <Flex justifyContent="flex-end" mt={4} gap={3}>
            <CancelButton onClick={onCancel} size="sm" />
            <SaveButton size="sm" isLoading={isCreating} />
          </Flex>
        }
      />
    </SkuOrderingPlatformItemContainer>
  );
}
